export default "__VITE_ASSET___lEWLKO1__"